import React, { useMemo, useEffect, useState } from 'react'
import camelcaseKeys from 'camelcase-keys'

import reserveApi from '../../../utils/axios'
import { ButtonLink } from '../../utils/Button'
import { Header } from '../../utils/Header'
import Tabs from '../../utils/Tabs'
import Imports from '../../Realtime/Imports'

const tabOptions = [
  { name: 'History', value: 'history' },
  { name: 'Availabilities', value: 'matches' }
]

export const Site = ({ match }) => {
  const [contentActive, setContentActive] = useState('history')
  const facilityId = useMemo(() => match.params.facilityId, [match])
  const siteId = useMemo(() => match.params.id, [match])

  const [site, setSite] = useState([])

  useEffect(() => {
    reserveApi.get(`/sites/${siteId}`).then(response => {
      setSite(camelcaseKeys(response.data, { deep: true }))
    })
  }, [facilityId, siteId])

  return (
    <div>
      <Header header={site.siteNum} subHeader={site.loop} />

      <Tabs options={tabOptions} onChange={setContentActive} />

      {contentActive === 'matches' && site.availabilities && (
        <div className="flex flex-wrap mt-6">
          {site.availabilities.map(avail => (
            <div key={avail.id} className="flex flex-col items-center p-3 border border-gray-200 mr-3 mb-3 rounded-md">
              <span className="text-4xl">{avail.length}</span>
              <span className="text-xl text-gray-500">{avail.availAt}</span>
            </div>
          ))}
        </div>
      )}
      {contentActive === 'history' && <Imports facilityId={facilityId} siteId={siteId} short />}
    </div>
  )
}

export default Site
